import { dateUtils } from '../date/index.js';

export const formatDatetime = (date, formatType, options) => {
  console.warn(
    '`formatDatetime(date, formatType, options)` is deprecated. ' +
    'Use `dateUtils.formatByName(date, formatName, [userConfig])` instead. (ui-framework-utils)'
  );

  return dateUtils.formatByName(date, formatType, options);
};
